module.exports = __webpack_public_path__ + "assets/dd3f8e01fe1efa28fe3981c3bb37c2b0.mp3";